import { Component, OnInit } from '@angular/core';
import { MasterDataService } from 'app/services/admin/master-data.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
   settingData: any;
  constructor(private _masterDataService: MasterDataService) { }

  ngOnInit(): void {

    this._masterDataService.getMasterData().subscribe({
      next: (res) => {
       this.settingData = res?.data;
      }
    });
  }

}
